define([], ()=> {
    /*
     * Angular bootstrap dropdown directive is used as basis
     * The biggest difference- append dropdown menu to content to prevent overflow: hidden; etc.
     *
     * dropdownToggle - Provides dropdown menu functionality in place of bootstrap js
     * @restrict class or attribute
     * @example:
     *    <li class="gw-pl-dropdown-wrapper">
     *        <a class="gw-pl-dropdown-toggle"
     *          [closest-element-to-listen]
     *          [event-to-listen]
     *          >My Dropdown Menu</a>
     *        <div class="gw-pl-dropdown-menu-wrapper">
     *          <ul class="dropdown-menu">
     *              <li ng-repeat="choice in dropChoices">
     *                  <a ng-href="{{choice.href}}">{{choice.text}}</a>
     *              </li>
     *          </ul>
     *        </div>
     *    </li>
     */

    return ['$document', ($document)=> {
        let openElement = null;
        let closeMenu = angular.noop;

        return {
            restrict: 'A',
            link: (scope, element, attrs)=> {
                // VARIABLES
                const $window = $(window);
                const $elToAppendMenu = element.closest('.gw-snap-content-inner');

                const $dropdownWrapper = element.parent();
                const $dropdownMenuWrapper = $dropdownWrapper.find('.gw-pl-dropdown-menu-wrapper');
                // elements for which "open" class would be added
                const $openClassEls = $dropdownWrapper.add($dropdownMenuWrapper);

                let $closestElementToListen = $();
                let eventToListen;
                if (attrs.closestElementToListen) {
                    $closestElementToListen = element.closest(attrs.closestElementToListen);
                    eventToListen = attrs.eventToListen;
                }

                // -----
                // ANGULAR BOOTSTRAP DROPDOWN DIRECTIVE CODE
                // -----
                scope.$watch('$location.path', ()=> {
                    closeMenu();
                });
                $dropdownWrapper.on('click', ()=> {
                    closeMenu();
                });
                element.on('click', (event)=> {
                    const elementWasOpen = (element === openElement);

                    event.preventDefault();
                    event.stopPropagation();

                    if (!!openElement) {
                        closeMenu();
                    }

                    if (!elementWasOpen && !element.hasClass('gw-disabled') && !element.prop('disabled')) {
                        $openClassEls.addClass('gw-open');
                        openElement = element;
                        closeMenu = ()=> {
                            //if (event) {
                            //    event.preventDefault();
                            //    event.stopPropagation();
                            //}

                            $document.off('click', closeMenu);

                            // additional code starts
                            $window.off('resize', closeMenu);
                            $closestElementToListen.off(eventToListen, closeMenu);
                            // additional code ends

                            $openClassEls.removeClass('gw-open');
                            closeMenu = angular.noop;
                            openElement = null;
                        };

                        $document.on('click', closeMenu);

                        // additional code starts
                        $window.on('resize', closeMenu);
                        refreshDropdownPosition();
                        $closestElementToListen.on(eventToListen, closeMenu);
                        $dropdownMenuWrapper.appendTo($elToAppendMenu);
                        // additional code ends
                    }
                });

                // -----
                // ADDITIONAL CODE
                // -----
                $dropdownMenuWrapper
                    .detach();// detach element to prevent page size change on appearing

                function refreshDropdownPosition() {
                    const elToAppendMenuOffset = $elToAppendMenu.offset();
                    const dropdownWrapperOffset = $dropdownWrapper.offset();
                    $dropdownMenuWrapper.css({
                        width: $dropdownWrapper.width(),
                        height: $dropdownWrapper.height(),
                        top: dropdownWrapperOffset.top - elToAppendMenuOffset.top,
                        left: dropdownWrapperOffset.left - elToAppendMenuOffset.left
                    }).appendTo($elToAppendMenu);
                }
            }
        };
    }];
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/dropdown/directives/DropdownDirective.js
 **/